export default __webpack_public_path__ + "static/media/24-460x460.de9da8e0.jpeg";